import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-validation',
    templateUrl: './validation.component.html',
    styleUrls: ['./validation.component.css'],
    standalone: false
})
export class ValidationComponent implements OnInit {

  @Input() validationMessage: string;
  @Input() id: string;
  constructor() { }

  ngOnInit() {
  }

}
